module.exports = __webpack_public_path__ + "static/media/blog-img2.9cc058d0.jpg";